// Exact code copy of the previous implemention:
// packages/checkout/src/common/ExtendProductWarranty/redux/extendWarranty.action.ts

import CartActionTypes from 'pages/Cart/redux/Cart.types';
import EApiMiddlewareMethod from 'config/redux/middlewares/api.middleware.enum';
import { Dispatch } from 'redux';

import { showNotification } from 'common/Notification/redux/notification.action';
import i18n from 'config/localisation';
import { getGUID } from 'utils/cookies.util';
import { notificationTypes } from 'common/Notification/redux/notification.type';
import { updateEntryToggleLoading } from 'pages/NewCart/redux/actions/updateQuantity.action';
import { cartReponseShaper } from 'pages/NewCart/redux/actions/cartAction.helper';
import { updateCart } from 'pages/NewCart/redux/actions/fetchCart.actions';
import { UPDATE_QUANTITY_API } from 'pages/NewCart/constants/api.constants';

export const updateExtendWarranty = ({
  warrantyCode,
  productCode,
  entryIndex,
  qty = 1,
  onFailure,
  offerId = '',
}: {
  warrantyCode: string;
  productCode: string;
  entryIndex: number | string;
  oldProductCode: string;
  qty?: number;
  isOffer?: boolean;
  onFailure: () => void;
  offerId?: string;
}) => (dispatch: Dispatch) => {
  dispatch(updateEntryToggleLoading(entryIndex, true));
  const guid = getGUID();

  const url = guid ? `${UPDATE_QUANTITY_API}&guid=${guid}` : UPDATE_QUANTITY_API;
  const data = {
    productId: productCode,
    serviceProductCode: [warrantyCode],
    quantity: qty,
    intent: '',
    offerId,
  };

  dispatch({
    type: CartActionTypes.CART_ADD_UPDATE_WARRANTY,
    payload: {
      headers: { 'content-type': 'application/json' },
      apiVersion: 3,
      enableProgress: false,
      data,
      method: EApiMiddlewareMethod.PUT,
      url,
      onSuccess: (cartResponse: { [key: string]: any }) => {
        const { cart } = cartResponse;
        updateCart(dispatch, cartReponseShaper(cart));
      },
      onFailure: () => {
        onFailure();
        dispatch(
          showNotification({
            type: notificationTypes.errorCheckout,
            message: i18n.t('extendWarrantyError'),
          })
        );
      },
      onFinally: () => {
        dispatch(updateEntryToggleLoading(entryIndex, false));
      },
    },
  });
};
